import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { AdminRoleService } from 'src/app/_api/services/role.service';
import { TimeStatusLogsService } from 'src/app/_api/services/timestatuslogs.service';
import { LanguageService } from 'src/app/shared/services/language.service';

@Component({
  selector: 'app-project-portal-list-detail-log',
  templateUrl: './project-portal-list-detail-log.component.html',
  styleUrls: ['./project-portal-list-detail-log.component.css']
})

export class ProjectPortalListDetailLogComponent implements OnInit, OnChanges {

  statusLogs = []; 
  statuses = []; 
  logs = []; 

  @ViewChild('dxDataGrid', {static:false}) datagrid: DxDataGridComponent;
  @Input() selectedTimeRecord: any;
  
  constructor(public languageService: LanguageService, public timeStatusLogsService: TimeStatusLogsService, public _adminRoleService: AdminRoleService) { }

  ngOnInit(): void {
    this.loadStatuses(); 
  }

  ngOnChanges(changes: SimpleChanges) {
    const hasChangedSelectedTimeRecord = changes.selectedTimeRecord !== undefined && changes.selectedTimeRecord.previousValue !== changes.selectedTimeRecord.currentValue;

    if (hasChangedSelectedTimeRecord === false) { return; }
    this.loadData();
  }

  private async loadData() {
    if (!this.selectedTimeRecord) { 
      this.statusLogs = []
      return; 
    }

    const asyncOperations: Promise<any>[] = [
      this.loadLogs(),
    ];

    await Promise.all(asyncOperations);
  }

  public getStatusText(statusId: number): string {
    if(statusId == null) return ""
    let status = this.statuses.find(s => s.StatusId === statusId);
    return status?.Description 
  }

  public getStatusStyleValue(statusId: number): string {
    let status = this.statuses.find(s => s.StatusId === statusId);
    if(status?.HTMLSettingStyleValue == null || statusId == null) return ""
    let style = `background: linear-gradient(to left, ${status.HTMLSettingStyleValue} 50px, rgba(0,0,0,0) 50px);`
    return style
  }

  private async loadLogs() {
    this.statusLogs = await this.timeStatusLogsService.getByTimeId(this.selectedTimeRecord.TimeId).toPromise();
  }

  private async loadStatuses() {
    this.statuses = await this._adminRoleService.getAllStatuses().toPromise();
  }

}
